import React, { Component } from 'react';
import logo from './logo.png';
import './App.css';
import Userinfo from './components/userinfo';
import Callstatus from './components/callstatus';
import 'abortcontroller-polyfill';
import 'url-search-params-polyfill';
import {setAuthToken} from './apis/api';

// Messages exchanged with the Help Hub window that opened this popup
const EC_READY = 'EC_READY';
const EC_AUTH = 'EC_AUTH';
const AUTH_TIMEOUT_MS = 15000;

class App extends React.Component {
  constructor(props) {
    super(props);
    const AbortController = window.AbortController;
    this.controller = new AbortController();
    this.signal = this.controller.signal;
    this.state = {
      login_popup: null,
      callback_popup: null,
      callstatus_popup: null,
      variables: '',
      contactId: '',
      dataValue: '',
      authReady: false,
      authFailed: false
    };
  }
  componentWillMount() {
    const params = new URLSearchParams(window.location.search)
    const dataValue = params.get('data');
    this.setState({dataValue: dataValue})
    const userDetails = window.atob(dataValue);
    this.setState({variables: JSON.parse(userDetails)});
  }
  componentDidMount() {
    window.addEventListener('message', this.onAuthMessage);
    this.authTimer = setTimeout(() => {
      if (!this.state.authReady) this.setState({ authFailed: true });
    }, AUTH_TIMEOUT_MS);
    if (window.opener) {
      // Carries no secret, so any origin may receive it. Help Hub only answers to this app's origin.
      window.opener.postMessage({ type: EC_READY }, '*');
    } else {
      this.setState({ authFailed: true });
    }
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.onAuthMessage);
    clearTimeout(this.authTimer);
  }
  //receive the access token from the Help Hub window that opened this popup
  onAuthMessage = (event) => {
    if (event.source !== window.opener || !event.data || event.data.type !== EC_AUTH || !event.data.token) return;
    setAuthToken(event.data.token);
    clearTimeout(this.authTimer);
    this.setState({ authReady: true, authFailed: false });
  }
  //set the state of the popup for callback page
  popupCallback = (popupState) => {
    this.setState({ login_popup: !popupState });
    this.setState({ callback_popup: popupState});
  }
  //close ewt modal popup
  ewtpopupCallback = (popupState) => {
    this.setState({ callback_popup: !popupState});
  }

  //set the state for call status page
  nextpopupCallback = (popupState) => {
    this.setState({ callback_popup: !popupState});
    this.setState({ callstatus_popup: popupState})
  }

  //get the variables from question screen to pass it to callback screen
  popupvariablesCallback = (showPopupVariables) => {
    this.setState({ variables : showPopupVariables })
  }
  //get the agent name from callback screen to pass it to callstatus screen
  contactIdCallback = (showContactId) => {
    this.setState({contactId: showContactId})
  }
  render() {
    return (
      <div className="App">
        <div className='form-textinput'>
          {this.state.authFailed ? <p>Unable to verify your session. Please close this window and try again from Help Hub.</p> : null}
          {this.state.authReady ?
            <Userinfo
              variablesFromLogin={this.state.variables} // Pass variables fetched from login comp./screen
              popupvariablesCallback={this.popupvariablesCallback} //Used for fetching state of the variables from popup comp./screen
              contactIdCallback={this.contactIdCallback} //used for fetching contactId
              skipToStatus={this.nextpopupCallback} //skip EWT modal, go straight to callstatus
            /> : null}
          {this.state.callstatus_popup ?
            <Callstatus
              variablesFromCallback={this.state.contactId} //Pass contactId information to callstatus comp./screen
              dataValueFromApp={this.state.dataValue} //Pass dataValue from App to callstatus screen.
            /> : null
          }
        </div>
      </div>
    );
  }
}

export default App;
